module.exports = __webpack_public_path__ + "img/basic-set.f81dd680.jpg";